import React, { useEffect } from 'react'
import i18n from 'constants/strings'
import styles from './signInDetails.module.scss'
import AccountSection from './AccountSection'
import BtnSecondary from 'components/generic/BtnSecondary'
import { ReactComponent as ExtLinkIcon } from 'images/icons/icn_ext-link.svg'
import UserApi from 'api/rest/user'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { getAccountEmail } from 'actions/user-actions'
import LoadingSpinnerWithContainer from 'components/generic/LoadingSpinnerWithContainer'
import InfoBox from 'components/generic/InfoBox'

const Wrapper = ({ children }) => {
  return (
    <AccountSection
      title={i18n.t('strMyAccount.signInDetails.title')}
      subtitle={i18n.t('strMyAccount.signInDetails.subtitle')}
    >
      {children}
    </AccountSection>
  )
}

const SignInDetailsInner = ({ emailAddress }) => {
  return (
    <>
      <h3>{i18n.t('strMyAccount.signInDetails.bodyTitle')}</h3>
      <table className={styles.table}>
        <tbody>
          <tr>
            <th>{i18n.t('strCommonUI.form.email')}:</th>
            <td>{emailAddress}</td>
          </tr>
          <tr>
            <th>{i18n.t('strCommonUI.form.password')}:</th>
            <td>***********</td>
          </tr>
        </tbody>
      </table>
      <div className={styles.btnsContainer}>
        <BtnSecondary
          size='medium'
          onClick={() => {
            UserApi.initChangeEmail()
          }}
          className={styles.btn}
          fullWidthAtMobile
        >
          <span>{i18n.t('strCommonUI.button.updateEmail')}</span>
          <ExtLinkIcon />
        </BtnSecondary>
        <BtnSecondary
          size='medium'
          onClick={() => {
            UserApi.initChangePassword()
          }}
          className={styles.btn}
          fullWidthAtMobile
        >
          <span>{i18n.t('strCommonUI.button.updatePassword')}</span>
          <ExtLinkIcon />
        </BtnSecondary>
      </div>
    </>
  )
}

const SignInDetails = () => {
  const dispatch = useDispatch()
  const { emailAddress, emailAddressLoading, emailAddressError } = useSelector(
    (state: AppState) => state.user
  )

  useEffect(() => {
    if (!emailAddress) {
      dispatch(getAccountEmail())
    }
  }, [dispatch, emailAddress])

  if (emailAddressError)
    return (
      <Wrapper>
        <InfoBox textOnly iconColor='red' boxColor='red'>
          {i18n.t('strMyAccount.infoError')}
        </InfoBox>
      </Wrapper>
    )

  if (!emailAddress || emailAddressLoading)
    return (
      <Wrapper>
        <LoadingSpinnerWithContainer />
      </Wrapper>
    )

  return (
    <Wrapper>
      <SignInDetailsInner emailAddress={emailAddress} />
    </Wrapper>
  )
}

export default SignInDetails
